
import { defineComponent, PropType } from 'vue'
import { CallStackFrame } from '~/types/types'

export default defineComponent({
  name: 'DependencyCodePath',
  props: {
    frame: {
      type: Object as PropType<CallStackFrame>,
      required: true
    }
  },
  computed: {
    showMethod(): boolean {
      return this.frame.method !== '(unnamed)'
    }
  }
})
